/* eslint-disable global-require */

/** @todo TO FINISH IT. */
export default [
  {
    path: 'account_types',
    name: 'account_types',
    resource: 'AccountType',
    roles: ['ROLE_ADMIN'],
    component: require('@/components/layout/view-layout').default,
    routes: [
      {
        path: '',
        name: 'list',
        context: 'read:list',
        exact: true,
        component: require('@/views/account-type/list').default,
        title: 'account_types_list_title',
        permissions: {
          AccountType: ['read:list']
        }
      },
      {
        path: '/create',
        name: 'create',
        component: require('@/views/account-type/form').default,
        title: 'account_types_create_title',
        permissions: {
          AccountType: ['create']
        }
      },
      {
        path: '/:id',
        name: 'update',
        component: require('@/views/account-type/form').default,
        title: 'account_types_update_title',
        permissions: {
          AccountType: ['read', 'update']
        }
      }
    ]
  }
];
